import React from 'react';
import ReactDOM from 'react-dom';
import registerServiceWorker from './registerServiceWorker';
import HomePage from './components/homepage.js';

//var MyRoutes = require("./components/MyRoutes.js").MyRoutes;


ReactDOM.render(<HomePage />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js